import { Link } from 'react-router-dom';
import { Play, BookOpen } from 'lucide-react';
import { Button } from '../components/ui/button';
import useQuranStore from '../store/quranStore';

export default function ResumeCard() {
  const { lastReading } = useQuranStore();

  if (!lastReading) return null;

  const timeAgo = (timestamp) => {
    const seconds = Math.floor((Date.now() - timestamp) / 1000);
    if (seconds < 60) return 'Just now';
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    return `${days}d ago`;
  };

  return (
    <div 
      className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary/10 via-primary/5 to-transparent border border-primary/20 p-6"
      data-testid="resume-card"
    >
      {/* Decorative pattern */}
      <div className="absolute top-0 right-0 w-32 h-32 opacity-10">
        <svg viewBox="0 0 100 100" className="w-full h-full text-primary">
          <pattern id="islamic-pattern" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
            <circle cx="10" cy="10" r="8" fill="none" stroke="currentColor" strokeWidth="0.5" />
            <circle cx="10" cy="10" r="4" fill="none" stroke="currentColor" strokeWidth="0.5" />
          </pattern>
          <rect width="100" height="100" fill="url(#islamic-pattern)" />
        </svg>
      </div>

      <div className="relative">
        <div className="flex items-center gap-2 mb-2">
          <BookOpen className="w-4 h-4 text-primary" />
          <span className="text-sm font-medium text-primary">Continue Reading</span>
        </div>

        <h3 className="text-xl font-serif mb-1">{lastReading.surahName}</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Ayah {lastReading.ayahNo} · {timeAgo(lastReading.timestamp)}
        </p>

        <Link to={`/surah/${lastReading.surahNo}?ayah=${lastReading.ayahNo}`}>
          <Button className="gap-2" data-testid="resume-reading-btn">
            <Play className="w-4 h-4" />
            Resume Reading
          </Button>
        </Link>
      </div>
    </div>
  );
}
